import dayjs from "dayjs";
import React from "react";
import getStatus from "./getStatus";
import ListDropdown from "./ListDropdown";
import {
  BatteriesColumn,
  EnergyConsumedColumn,
  EnergyRevenueColumn,
} from "./CustomColumns";

export const rentalColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Rental ID
      </div>
    ),
    dataIndex: "id",
    sorter: (a, b) => a.id - b.id,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron text-black py-2.5">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Vehicle ID
      </div>
    ),
    dataIndex: "trikeRegistrationNo",
    sorter: (a, b) =>
      a.trikeRegistrationNo.localeCompare(b.trikeRegistrationNo),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron text-black py-2.5">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Driver
      </div>
    ),
    dataIndex: "id",
    sorter: (a, b) => a?.firstName?.localeCompare(b?.firstName),
    render: (text, record) => {
      const name = record?.firstName
        ? `${record?.firstName} ${record?.lastName}`
        : "--";

      return (
        <div className="text-xs font-semibold font-aileron text-black py-2.5 capitalize">
          {name}
        </div>
      );
    },
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Dispatched From
      </div>
    ),
    dataIndex: "hubName",
    sorter: (a, b) => a.hubName?.localeCompare(b.hubName),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron text-dark-gray whitespace-nowrap capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Batteries Used
      </div>
    ),
    dataIndex: "batteries",
    sorter: (a, b) => a.batteries.length - b.batteries.length,
    render: (text, record) => {
      return (
        <div role="button" onClick={(e) => e.stopPropagation()}>
          <BatteriesColumn record={record} />
        </div>
      );
    },
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Total Energy Consumed
      </div>
    ),
    dataIndex: "energyConsumed",
    // sorter: (a, b) => a.energyConsumed - b.energyConsumed,
    render: (text, record) => <EnergyConsumedColumn record={record} />,
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Energy Revenue Generated
      </div>
    ),
    dataIndex: "revenue",
    // sorter: (a, b) => a.revenue - b.revenue,
    render: (text, record) => <EnergyRevenueColumn record={record} />,
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Date & Duration
      </div>
    ),
    dataIndex: "submittedAt",
    sorter: (a, b) => a?.submittedAt?.localeCompare(b?.submittedAt),
    render: (text) => (
      <div>
        <p className="text-xs font-semibold font-aileron text-dark-gray whitespace-nowrap">
          {dayjs(text).format("ddd, MMM DD, YYYY")}
        </p>

        <p className="text-10 font-normal font-aileron text-dark-gray uppercase">
          {dayjs(text).format("hh:mm a")}
        </p>
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Status
      </div>
    ),
    dataIndex: "status",
    sorter: (a, b) => a.status - b.status,
    render: (text, record) => <div>{getStatus(record)}</div>,
  },
  {
    dataIndex: "id",
    width: "80px",
    render: (text, record) => (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="w-full flex items-center justify-center invisible group-hover:visible"
      >
        <ListDropdown detail={record} />
      </button>
    ),
  },
];
